import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMenuComponent } from "./med-icon-menu.component";

@NgModule({
  declarations: [
    MedIconMenuComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMenuComponent,
  ],
})
export class MedIconMenuModule { }
